// extracted by css-extract-rspack-plugin
var _1 = "WjY8Zmr8MIxUQx3F";
var _2 = "O1cnZRq9XJc_x6Un";
var _3 = "O1cnZRq9XJc_x6Un";
export { _1 as "filtered", _2 as "standings-box", _3 as "standingsBox" }
